import Swiper from 'swiper/bundle'

// Services Slides
let services = document.getElementsByClassName('slider__cards')
let servicesOptions = {
    speed: 400,
    centeredSlides: true,
    slideToClickedSlide: true,
    centeredSlidesBounds: true,
    watchOverflow: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
}

for ( var i = 0, len = services.length; i < len; i++ ) {
	new Swiper( services[ i ], servicesOptions )
}
